import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify/index.js'
import '@/stylus/main.styl'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import { App } from './app'
// import './registerServiceWorker'
import VeeValidate from 'vee-validate'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import Vue2TouchEvents from 'vue2-touch-events'
import '@mdi/font/css/materialdesignicons.min.css'

import YmapPlugin from 'vue-yandex-maps'
const options = { // you may define your apiKey, lang and version or skip this.
  apiKey: '', // '' by default
  lang: 'ru_RU', // 'ru_RU' by default
  version: '2.1' // '2.1' by default
}
Vue.use(YmapPlugin, options)
Vue.use(Vue2TouchEvents)

sync(store, router)

Vue.use(VeeValidate)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
